import src from "IMAGE";
export default { src, width: 1466, height: 148, blurWidth: 0, blurHeight: 0};
